import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button, FormField } from "@weirgroup/weir-dls";
import { updateQuantity } from "../../../api/shopping-list.api";
import { ShoppingListItem } from "../../../types/shopping-list.type";
import { SetFunctionType } from "../../../types/utils.type";
import { processResult } from "../../../utils/process-result.util";
import { useAnalyticsEvent } from "../../../hooks/useAnalyticsEvent";
import { LoadingSpinner } from "../../../components/loading-spinner";
interface Props {
    isModalShown: boolean
    setIsModalShown: Dispatch<SetStateAction<boolean>>
    shoppingListItem: ShoppingListItem | null
    setToastData: Dispatch<SetStateAction<any>>
    setShowToast: Dispatch<SetStateAction<any>>
    fetchShoppingList: () => void
    darkMode?:boolean
}

export const QuantityModal = (props: Props) => {
    const {
        isModalShown,
        setIsModalShown,
        shoppingListItem,
        setToastData,
        setShowToast,
        fetchShoppingList
    } = props;
    const { t } = useTranslation();
    const logAnalyticsEvent = useAnalyticsEvent();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [quantity, setQuantity] = useState<number>(1)
    const preventKeys = ["e", "E", "+", "-", "."];
    const setFunctions: SetFunctionType = { setIsModalShown, setToastData, setShowToast, setIsLoading }
    const saveQuantity = () => {
        if (quantity > 0) {
            setIsLoading(true)
            updateQuantity(shoppingListItem!.shopping_cart_item_id, quantity).then((result: any) => {
                processResult(setFunctions, t('quantitySaveSuccessMessage'), true)
                fetchShoppingList();    
                logAnalyticsEvent('web_user_updated_quantity_of_shopping_list_item', { description: 'User updated the quantity of a shopping list item' });
            }).catch((err: any) => {
                const message = err.response.data.message ?? t('quantitySaveFailMessage')
                processResult(setFunctions, message, false)
                fetchShoppingList();
            })
        } else if (!Number.isInteger(quantity)) {
            setToastData({
                variant: "critical",
                message: t('quantityIntegerChecker')
            })
            setShowToast(true)
        } else {
            setToastData({
                variant: "critical",
                message: t('quantityGreaterThanZero')
            })
            setShowToast(true)
        }
    }

    return (
        <div className={isLoading ? "disable-pointer quantity-modal" : "quantity-modal"}>
            {isLoading ?<LoadingSpinner darkMode={props.darkMode} />: <></>
            }
            <Modal
                darkMode={props.darkMode}
                showModal={isModalShown}
                onClose={() => setIsModalShown(false)}
                size="small"
                dismissable={true}
            >
                <div className="content">
                    <p className="title" style={{color: props.darkMode ? "white" : "black"}}>{t("editShoppingListItem")}</p>
                    <FormField
                        darkMode={props.darkMode}
                        name="InputBox"
                        required={true}
                        label={t("quantity")}
                        type={"number"}
                        size={"sm"}
                        width={"100%"}
                        placeholder={t("enterQuantity")}
                        onChange={(e: any) => setQuantity(e.target.value)}
                        onKeyDown={(e: any) => preventKeys.includes(e.key) && e.preventDefault()}
                        defaultValue={shoppingListItem?.quantity}
                    />
                    <div className="save-btn">
                        <Button
                            darkMode={props.darkMode}
                            label={t("save")}
                            size={"sm"}
                            variant={"primary"}
                            onClick={saveQuantity}
                            iconName={"Save"}
                        />
                    </div>
                </div>
            </Modal>
        </div>
    )
}